import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";

export const usePastDaysLimit = (): number => {
  const {
    data: { availability }
  } = useMyAccountInfo();

  const { past_days_limit: pastDaysLimit } = availability || {};

  return pastDaysLimit ?? 0;
};
